<template>
<v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
        <v-col cols="12">
            <i-card-vertical :headerTitle="menuTitle" :useBtnList="useBtnList" @btnRetrieve="btnRetrieve()" @btnPrint="btnPrint()" @btnExcel="btnExcel()">
                <template v-slot:body>
                    <v-row>
                        <v-col cols="12" class="pa-0">
                            <i-card-top class="d-md-flex" outlined>
                                <template v-slot:body>
                                    <v-row no-gutters class="center pa-0 pl-1">
                                        <v-col cols="12">
                                            <v-row dense class="ma-0">
                                                <v-icon small color="blue" class="pt-1">mdi-circle</v-icon>
                                                <span class="pa-2 pr-0">Ship No : </span>
                                                <v-col cols="1">
                                                    <v-select v-model="shipNo" :items="shipNoList" item-value="shipNo" return-object single-line outlined dense @change="btnRetrieve()" ></v-select>
                                                </v-col>
                                                <v-icon small color="blue" class="pl-2 pt-1">mdi-circle</v-icon>
                                                <span class="pa-2 pr-0">Period : </span>
                                                <v-col cols="1">
                                                    <DxDateBox :value="stDate" height="30px" display-format="yyyy-MM-dd" :acceptCustomValue="false" @value-changed="e => {stDate = e.value && getStrFormat(e.value)}" />
                                                </v-col>
                                                <span class="pa-2"> ~ </span>
                                                <v-col cols="1" class="pl-0">
                                                    <DxDateBox :value="edDate" height="30px" display-format="yyyy-MM-dd" :acceptCustomValue="false" @value-changed="e => {edDate = e.value && getStrFormat(e.value)}" />
                                                </v-col>

                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </template>
                            </i-card-top>
                        </v-col>
                    </v-row>

                    <v-row no-gutters>
                        <v-col cols="12" class="pt-1">
                            <DxDataGrid id="v80a1030" :ref="v80a1030Ref" class="listBox" :data-source="gridMainList" :remote-operations="false" :hover-state-enabled="true" :allow-column-resizing="true" :allow-column-reordering="true" :row-alternation-enabled="true" :show-borders="true" :width="grid.width" :show-row-lines="true" key-expr="id" :focused-row-enabled="true" :column-hiding-enabled="false" :sorting="{ mode: 'none' }" :selection="{ mode: 'none' }" :word-wrap-enabled="true" > 

                                <DxColumn data-field="no" caption="No" width="3%" data-type="number" format="#,###" alignment="center" :allow-editing="false" />
                                <DxColumn data-field="shipNo" caption="Ship No" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                                <DxColumn data-field="erectBlk" caption="Erection" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                                <DxColumn data-field="block" caption="Block" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                                <DxColumn data-field="blockNm" caption="Block Name" width="20%" data-type="string" alignment="center" :allow-editing="false" />
                                <DxColumn data-field="blkType" width="7%" data-type="string" header-cell-template="type" alignment="center" :allow-editing="false" />
                                <template #type>
                                    <div>
                                        <span>Plate<br>Type</span>
                                    </div>
                                </template>
                                <DxColumn caption="Block Weight" data-type="string" alignment="center" :allow-editing="false">
                                    <DxColumn data-field="wkVol" caption="Activity" width="8%" data-type="string" alignment="center" :allow-editing="false" />
                                    <DxColumn data-field="blkWtEst" caption="Block Div" width="8%" data-type="string" alignment="center" :allow-editing="false" />
                                    <DxColumn data-field="blkWt" caption="PP Plan" width="8%" data-type="string" alignment="center" :allow-editing="false" />
                                </DxColumn>

                                <DxColumn data-field="mfgInd" caption="Factory" width="8%" data-type="string" alignment="center" :allow-editing="false" />
                                <DxColumn caption="Work Plan" data-type="string" alignment="center" :allow-editing="false">
                                    <DxColumn data-field="wkStPlDt" caption="Start Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                                    <DxColumn data-field="wkFiPlDt" caption="Finish Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                                </DxColumn>
                                <DxColumn data-field="dur" caption="Period" width="8%" data-type="string" alignment="center" :allow-editing="false" />
                                
                                <DxColumn data-field="erectBuf" width="8%" data-type="string" header-cell-template="buffer" alignment="center" :allow-editing="false" />
                                <template #buffer>
                                    <div>
                                        <span>Waiting<br>Buffer</span>
                                    </div>
                                </template>
                                
                                <DxColumn data-field="erectDt" caption="Erection Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />

                                <DxSummary>
                                    <DxTotalItem column="shipNo" summary-type="count" display-format="Total" />
                                    <DxTotalItem column="block" summary-type="count" :customize-text="totalFormat" />
                                    <DxTotalItem column="wkVol" summary-type="sum" :customize-text="totalFormat" />
                                    <DxTotalItem column="blkWtEst" summary-type="sum" :customize-text="totalFormat" />
                                    <DxTotalItem column="blkWt" summary-type="sum" :customize-text="totalFormat" />
                                    <DxTotalItem column="erectBuf" summary-type="avg" :customize-text="totalFormat" />

                                    <!-- <DxTotalItem column="accAmt" summary-type="sum" :customize-text="totalFormat" alignment="right" />
                                    <DxTotalItem column="totAmt" summary-type="sum" :customize-text="totalFormat" />  -->
                                </DxSummary>

                                <DxPaging :enabled="true" :page-size="30" />
                                <DxPager :visible="true" :showInfo="false" />
                            </DxDataGrid>
                        </v-col>
                    </v-row>
                    
                </template>
            </i-card-vertical>
        </v-col>
    </v-row>
</v-container>
</template>

<script>
import {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxLookup,
    DxSelection,
    DxPager
} from 'devextreme-vue/data-grid'
import DxDateBox from 'devextreme-vue/date-box'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { getNumComma, toNum } from '@/utils/common.js'
import {  getV80ShipNo } from '@/api/view/hip/8/v80a1040.js'
import {
    v80a1030List, v80a1030Xls
} from '@/api/view/hip/A/v80a1030.js'
import {
    reportView
} from '@/api/view/hip/common/common.js'

import {
    getDateFormat,
    getCurrentDate
} from '@/utils/common.js'
import dayjs from 'dayjs';
import notify from 'devextreme/ui/notify' // message

export default {
    name: 'v80a1030',
    mixins: [baseview, BaseDataGrid],
    components: {
        ICardVertical,
        "i-card-top": iCardTop,
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxDateBox,
        DxLookup,
        DxSelection,
        DxPager
    },
    data() {
        return {
            menuTitle: this.$route.meta.title,
            useBtnList: ['btnRetrieve', 'btnPrint', 'btnExcel'],
            v80a1030Ref: 'v80a1030Ref',
            gridMainList: [],

            stDate: null,
            edDate: null,

            shipNo: '',
            shipNoList: [],

            listSize: 0,

        }
    },
    computed: {
        gridMainInstance() {
            return this.GetDataGrid(this.v80a1030Ref)
        },
    },
    mounted() {
        this.init()
        this.gridMainInstance.option('defaultPaging', false)
    },
    methods: {
        totalFormat(e) {
            const result = getNumComma(Number(e.value.toFixed(2)), 2)
            return result
        },
        getStrFormat(date) {
            return getDateFormat(date)
        },
        init() {
            let toDay = new Date
            this.stDate = toDay.setDate(toDay.getDate() - 60);
            toDay = new Date
            this.edDate = toDay.setDate(toDay.getDate() + 30);

            this.stDate = dayjs(this.stDate).format('YYYY-MM-DD')
            this.edDate = dayjs(this.edDate).format('YYYY-MM-DD')

            this.getList()
        },
        async getList() {
            try {
                this.openLoading('searching')
                let params = {
                    shipGu: ''
                }
                getV80ShipNo(params).then(res => {
                    this.shipNoList.push('All')
                    res.list.forEach(e => {
                        this.shipNoList.push(e.shipNo)
                    });
                    this.shipNo = this.shipNoList[0]
                })
               

            } finally {
                this.endLoading()
            }
        },
        async getMainList() {
            try {
                this.openLoading('searching')
                
                let params = {
                    stDate: this.stDate,
                    edDate: this.edDate,
                    shipNo: this.shipNo === 'All' ? '' : this.shipNo
                }
                await v80a1030List(params).then(res => {
                    res.list.forEach(e => {
                        e.id = e.no

                    });
                    this.gridMainList = res.list
                    this.listSize = res.list.length
                })

            } finally {
                this.endLoading()
            }
        },
        
        btnRetrieve() {

            this.getMainList()
        },
        btnPrint() {
            
            const param = {
                fileName: 'v80a1030.jrxml',
                as_ship_no: this.shipNo === 'All' ? '' : this.shipNo,
                as_st_date: this.stDate,
                as_fi_date: this.edDate                
            }
            this.openLoading('searching')
            reportView(param)
                .finally(() => {
                    this.endLoading()
                })
        },
        
        btnExcel() {
            this.openLoading('Saving Excel!')
            let params = {
                stDate: this.stDate,
                edDate: this.edDate,
                shipNo: this.shipNo === 'All' ? '' : this.shipNo
            }

            v80a1030Xls(params).finally(() => {             
                this.endLoading();
            })
            
        },
        //cell merge ,color
        // cellPrepared(e) {
        //     if (e.rowType === 'data') {
                
        //     }
        // },
    }
}
</script>

<style lang="scss" scoped>
.subText {
    font-weight: bold;
    color: black;
}

$redBtn: #FF0000;

.setBtnColor::v-deep {
    [role=btnDelete] {
        .v-btn__content {
            div {
                color: #{$redBtn} !important;
            }

            i {
                color: #{$redBtn} !important;
            }
        }
    }
}
</style>
